module.exports = __webpack_public_path__ + "media/images/social-share-button/vkontakte-208e34b14ccfde55a4127e3f20d835ec.svg";